import { useMemo, useState } from 'react';

export interface PaginationResult<T> {
  page: number;
  totalPages: number;
  pageItems: T[];
  start: number;
  end: number;
  total: number;
  setPage: (page: number) => void;
}

export function usePagination<T>(items: T[], pageSize: number): PaginationResult<T> {
  const [page, setPage] = useState(1);
  const total = items.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const clampedPage = Math.min(page, totalPages);
  const start = (clampedPage - 1) * pageSize;
  const pageItems = useMemo(() => items.slice(start, start + pageSize), [items, start, pageSize]);

  return {
    page: clampedPage,
    totalPages,
    pageItems,
    start: total === 0 ? 0 : start + 1,
    end: Math.min(start + pageSize, total),
    total,
    setPage,
  };
}
